<app-page-meta pageTitle="finzy - Loan Repayment Information"></app-page-meta>

<div class="container-fluid">
  <div class="row">
    <div class="col-xs-12">

      <div class="row finzy-row5">
        <p class="text-color-finzy-blue font-largest font-weight-bold text-center mb-0">LOAN DETAILS</p>
        <p *ngIf="!isZipDisbursedLoan; else zipDisbursedLoanStatus"
          class="font-medium text-center mb-0 mt-3 text-color-dark-grey">Loan Status - <span
            class="dark font-weight-bold"> {{ displayableLoanSanctionStatus }} </span></p>
        <ng-template #zipDisbursedLoanStatus>
          <p class="font-medium text-center mb-0 mt-3 text-color-dark-grey">Loan Status - <span
              class="dark font-weight-bold">Active</span></p>
        </ng-template>

        <p class="finzy-prepayment" *ngIf="ifPrePayment">Your loan has been Prepaid Completely and Closed</p>

        <div class="row finzy-row2" *ngIf="ifPrePayment">
          <i class="material-icons clock">access_time</i>
          <p class="finzy-p61">You can apply for a new loan </p>
          <p class="finzy-p61">only after <b> 6 months</b></p>
        </div>

        <span *ngIf="!isZipDisbursedLoan; else zipDisbursedLoanDetails">
          <p class="subheading text-center mt-2 mb-0" *ngIf="!ifPrePayment"><span class="dark">₹ <span
                class="font-weight-bold"> {{loan_fulfilled_amount | number : fractionSize}} </span></span>
            &nbsp;@&nbsp; <span class="dark font-weight-bold">{{roi}}% &nbsp;</span> for&nbsp; <span
              class="dark font-weight-bold">{{loan_tenure}}</span>&nbsp;Months,&nbsp;
            EMI &nbsp;<span class="dark">₹ <span class="font-weight-bold"> {{emi_amount | decimal | number :
                fractionSize}} </span> </span></p>

          <div class="row col-md-12 pt-3 text-center">
            <div class="col-md-2"></div>
            <div class="col-md-4">
              <p class="subheading mb-0 font-bold">Total Amount Repaid</p>
              <p class="text-muted line-height-1">(Via EMI &amp; Prepayment)</p>
              <p class="finzy-p8 font-medium font-sm-larger">₹ <span class="font-weight-bold"> {{repaidAmt | decimal |
                  number : fractionSize}} </span> </p>
            </div>
            <div class="col-md-4">
              <p class="subheading mb-0 font-bold">Total Outstanding</p>
              <p class="text-muted line-height-1">(Excluding Delay Charges)</p>
              <p class="finzy-p8 font-medium font-sm-larger">₹ <span class="font-weight-bold"> {{amtDue | decimal |
                  number : fractionSize}} </span> </p>
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 mt-5">
              <p class="text-center note">Note: The outstanding amounts displayed are based on the EMI schedule and do
                not
                consider delays (if any). <br /> In case of a delay, you will be sent the outstanding due via an email.
              </p>
            </div>
          </div>
        </span>

        <ng-template #zipDisbursedLoanDetails>
          <p class="subheading text-center mt-2 mb-0" *ngIf="!ifPrePayment"><span class="dark">₹ <span
                class="font-weight-bold"> {{loanAmount | number : fractionSize}}</span> </span>
            &nbsp;@&nbsp; <span class="dark font-weight-bold">{{roi}}% &nbsp;</span> for&nbsp; <span
              class="dark font-weight-bold">{{loan_tenure}}</span>&nbsp;Months,&nbsp;
            EMI &nbsp;<span class="dark">₹ — </span>
            <app-tooltip placement="bottom">
              <i class="fa fa-info-circle" trigger></i>
              <div content style="width: 30vw; max-width: 200px">
                <div class="row p-0 m-0">
                  <p style="padding: 0px;">
                    Your EMI details will be updated here shortly
                  </p>
                </div>
              </div>
            </app-tooltip>
          </p><br>
          <p class="dark text-center">Total <span class="font-weight-bold">Outstanding</span> &amp; <span
              class="font-weight-bold">Repaid Amount</span> will be updated here once the EMI schedule is generated.</p>
          <br>
        </ng-template>

        <div class="text-center col-md-12 finzy-txt-ps72 pt-5 pb-5 pl-0 pr-0 mt-5 ml-0 mr-0"
          *ngIf="latestLoanRestructuring">
          <p class="big-text font-bold mb-4">Details prior to Restructuring</p>
          <div class="text-muted medium-big-text">
            <p class="col-md-1"></p>
            <p class="col-md-5">Original Loan Amount: ₹ <span class="dark">{{ loanAmt | decimal | number : fractionSize
                }}</span> @ <span class="dark">{{ latestLoanRestructuring.oldYearlyRoiInPercentage }}%</span> ROI </p>
            <p class="col-md-6">Principal Outstanding before Restructuring: ₹ <span class="dark">{{
                latestLoanRestructuring.oldPrincipalOutstanding | decimal | number : fractionSize }}</span> </p>
          </div>
        </div>


        <div class="background-gray d-flex mt-4 p-5 align-items-center rounded">
          <div class="row">
            <div class="col-sm-12 col-md-8 text-left">
              <h4 class="font-weight-bold">You can pay EMIs or Part/Full Prepay your loan</h4>
              <ng-container>
                <span>
                  Principle Outstanding herein refers to the balance as per the EMI schedule without taking into account
                  accrued interest or
                  delays (if any). In case of payment of delayed EMI, please reach out to us at <a
                    href="mailto:support@finzy.com" target="_blank">support@finzy.com</a>
                  to get the penal interest
                  and charges.
                </span>
              </ng-container>
            </div>

            <div class="col-sm-12 col-md-4 my-2 text-right">
              <button id="pay-emi" mat-flat-button class="primary mx-4" (click)="prePayHandler()">
                PREPAY
              </button>
              <button mat-flat-button class="primary" (click)="payEmiHandler()">
                PAY EMI
              </button>
            </div>
          </div>
        </div>

        <div class="background-gray d-flex flex-wrap mt-4 p-5 align-items-center justify-content-between rounded">
          <span class="font-weight-bold">Keep track of your transactions and view signed documents</span>

          <div class="d-inline mt-2 mt-4 mt-sm-0">
            <span class="action-label font-weight-bold mr-5">
              <a [routerLink]="['passbook']">View Passbook</a>
            </span>
            <span class="action-label font-weight-bold mt-2 mt-sm-0">
              <a [routerLink]="['documents']">View Documents</a>
            </span>
          </div>
        </div>

        <div *ngIf="!isZipDisbursedLoan; else zipDisbursedLoanEmiScheduleInfo" class="mt-5 overflow-scroll">
          <mat-tab-group>
            <mat-tab label="{{getEmiScheduleLabel()}}">
              <mat-table #table [dataSource]="dataSource" matSort>

                <ng-container matColumnDef="due_on">
                  <mat-header-cell *matHeaderCellDef mat-sort-header> Date</mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.due_on | dateFormat}}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="emi_amount">
                  <mat-header-cell *matHeaderCellDef mat-sort-header> EMI</mat-header-cell>
                  <mat-cell *matCellDef="let element"> ₹ {{getApplicableEffectiveEmiAmount(element) | number :
                    fractionSize}}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="balance_amount">
                  <mat-header-cell *matHeaderCellDef mat-sort-header> Balance Principal Amount</mat-header-cell>
                  <mat-cell *matCellDef="let element"> ₹ {{getApplicablePrincipalOutstanding(element) | decimal | number
                    : fractionSize}}
                  </mat-cell>
                </ng-container>

                <ng-container matColumnDef="remaining_tenure">
                  <mat-header-cell *matHeaderCellDef mat-sort-header> Tenure Balance</mat-header-cell>
                  <mat-cell *matCellDef="let element"> {{element.remaining_tenure + 1}}</mat-cell>
                </ng-container>

                <ng-container matColumnDef="emi_status">
                  <mat-header-cell *matHeaderCellDef mat-sort-header>EMI Status</mat-header-cell>
                  <mat-cell *matCellDef="let element" [ngClass]="{
                    'text-warn' : element.emi_displayable_status === 'Unpaid',
                    'text-active' : element.emi_displayable_status === 'Paid' }"> {{element.emi_displayable_status}}
                  </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
              </mat-table>
              <mat-paginator #paginator [length]="5" [pageSize]="5" [pageSizeOptions]="[5, 10, 20]">
              </mat-paginator>
            </mat-tab>
          </mat-tab-group>
        </div>
        <ng-template #zipDisbursedLoanEmiScheduleInfo>
          <mat-tab-group>
            <mat-tab label="{{getEmiScheduleLabel()}}">
              <br>
              <p class="text-left font-weight-bold dark">Your EMI schedule will be generated and displayed over here. In
                addition, we will also send you email and SMS reminder before your EMI due date.</p>
            </mat-tab>
          </mat-tab-group>
        </ng-template>
      </div>

      <div class="row finzy-row4">
        <p class="finzy-p6">If you need assistance you can find help here <a target="_blank" [routerLink]="['/faq']"
            class="finzy-col">FAQs</a>.
          You could even call us on 9341 300 300. We are always happy to help!</p>
      </div>
    </div>
  </div>
</div>